import { QueryVariables } from 'features/inventory/domain/components/DomainsTable/types/api'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DOMAIN_FOR_TABLE_FRAGMENT } from './fragment'
import { Data } from './types'

export const GET_DOMAINS_FOR_TABLE: TypedDocumentNode<Data, QueryVariables> = gql`
  ${DOMAIN_FOR_TABLE_FRAGMENT}

  query getDomainsForTable(
    $workspaceId: ID!
    $first: Int
    $last: Int
    $terms: [String!]
    $sort: DomainSortInput
  ) {
    domains(workspaceId: $workspaceId, first: $first, last: $last, terms: $terms, sort: $sort) {
      nodes {
        ...DomainFragmentForTable
      }

      totalCount
    }
  }
`
